import React, { useState, useEffect } from 'react';

import {
  StockOrders,
  OptionOrders,
  Trade,
  Analysis,
  Gex,
} from './components';

import Tabs from "components/Tabs";
import { connect } from "react-redux";
import * as actions from "redux/actions/dashboardActions";
import {
  ANALYSIS_TAB_LABEL,
  ANALYSIS_KIND_OPTION,
  subscribePortfolioAnalysis,
} from 'utils/portfolioNav';

const Dashboard = (props) => {
  const [activeTab, setActiveTab] = useState('Option');
  const [analysisFocus, setAnalysisFocus] = useState({
    kind: ANALYSIS_KIND_OPTION,
    id: null,
  });

  useEffect(() => {
    props.loadListIndicator(props.user_id, props.token);
  }, props.data);

  useEffect(() => {
    return subscribePortfolioAnalysis((payload) => {
      setAnalysisFocus(payload || { kind: ANALYSIS_KIND_OPTION, id: null });
      setActiveTab(ANALYSIS_TAB_LABEL);
    });
  }, []);

  return (
    <div className="portfolio-page">
      <div className="portfolio-header">
        <div>
          <h1 className="portfolio-title">Portfolio</h1>
          <p className="portfolio-subtitle">
            Overview of your net liquidity, performance and open positions.
          </p>
        </div>
      </div>

        <Tabs activeTab={activeTab} onTabChange={setActiveTab}>
          <div label={"Option"} className="col-12">
            <OptionOrders />
          </div>
          <div label={"Stock"} className="col-12">
            <StockOrders />
          </div>
          <div label={"Trade"} className="col-12">
            <Trade />
          </div>
          <div label={ANALYSIS_TAB_LABEL} className="col-12">
            <Analysis analysisFocus={analysisFocus} />
          </div>
          <div label="GEX" className="col-12">
            <Gex />
          </div>
        </Tabs>

    </div>
  );
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    data: reducer.dashboard.data,
  };
}

const mapDispatchToProps = dispatch => ({
  loadListIndicator: (user_id, token) =>
    dispatch(actions.loadListIndicator({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
